import PlayerCard from "./components/PlayerCard"
import './index.css'

const GridPlayers = ({players, vote})=>{
        const renderPlayerList = ()=>{
        // if(filterPlayers?.length <= 0 || keyword === '') return <></>
        return <>
            {
              players?.map((player, i)=>(<PlayerCard  player={player?.jugador || player} handleVoteByPlayer={vote}/>))
            }
        </>
        
    }
    return( <div className="grid-players-container" >
                { renderPlayerList()}
            </div>

    )
}

export default GridPlayers